import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/Batteries";

export const GetAll = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetAll`, options);

export const GetBatteryList = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetBatteryList`, options);

export const Create = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Create`, options);

export const GetById = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetById/:id`, options);

export const Update = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Update/:id`, options);

export const Delete = (options) =>
  GENERATE_URL(`${PREFIX_URL}/Delete/:id`, options);

export const CalculateCondenserBattery = (options) =>
  GENERATE_URL(`${PREFIX_URL}/CalculateCondenserBattery`, options);

export const CalculateEvaporatorBattery = (options) =>
  GENERATE_URL(`${PREFIX_URL}/CalculateEvaporatorBattery`, options);

export const UpdateLockStatus = (options) =>
  GENERATE_URL(`${PREFIX_URL}/UpdateLockStatus/:id`, options);

export const GetBatteryLogs = (options) =>
  GENERATE_URL(`${PREFIX_URL}/GetBatteryLogs`, options);

export const ReactivateBattery = (options) =>
  GENERATE_URL(`${PREFIX_URL}/ReactivateBattery`, options);

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
  CalculateCondenserBattery,
  CalculateEvaporatorBattery,
  UpdateLockStatus,
  GetBatteryLogs,
  ReactivateBattery,
  GetBatteryList,
};
